// AUTO-GENERATED from the reference application audit records (source of truth).
// Daily/Weekly QA-FSSAI checklist templates. Edit here to add/adjust checkpoints.
export const AUDIT_TEMPLATES = {
  "Daily": [
    {
      "name": "Hygiene & Food Safety",
      "shortName": "Hygiene",
      "key": "hygiene",
      "critical": true,
      "checkpoints": [
        {
          "name": "Hand-wash stations are clean and adequately stocked",
          "priority": "high"
        },
        {
          "name": "Soap and hand-drying facilities available",
          "priority": "high"
        },
        {
          "name": "Staff follow proper hand-washing practices",
          "priority": "high"
        },
        {
          "name": "No jewellery, watches or loose personal items in production",
          "priority": "normal"
        },
        {
          "name": "No uncovered food or exposed ingredients",
          "priority": "critical"
        },
        {
          "name": "No cross-contamination between raw and finished products",
          "priority": "critical"
        },
        {
          "name": "Food-contact surfaces are clean and sanitized",
          "priority": "critical"
        },
        {
          "name": "Production floors and drains are clean",
          "priority": "normal"
        },
        {
          "name": "Pest activity / signs are absent",
          "priority": "critical"
        },
        {
          "name": "Cleaning chemicals are stored away from food",
          "priority": "high"
        },
        {
          "name": "Temperature-sensitive ingredients handled correctly",
          "priority": "critical"
        },
        {
          "name": "No expired or visibly spoiled ingredients being used",
          "priority": "critical"
        }
      ]
    },
    {
      "name": "Staff Grooming & Personal Hygiene",
      "shortName": "Grooming",
      "key": "grooming",
      "critical": false,
      "checkpoints": [
        {
          "name": "Clean uniform",
          "priority": "normal"
        },
        {
          "name": "Hairnet / cap worn correctly",
          "priority": "high"
        },
        {
          "name": "Beard cover used where applicable",
          "priority": "high"
        },
        {
          "name": "Nails short and clean",
          "priority": "normal"
        },
        {
          "name": "No jewellery",
          "priority": "normal"
        },
        {
          "name": "Appropriate footwear",
          "priority": "normal"
        },
        {
          "name": "No eating / drinking in production area",
          "priority": "high"
        },
        {
          "name": "No mobile phone use in production area",
          "priority": "normal"
        },
        {
          "name": "Staff appear fit and hygienic for food handling",
          "priority": "high"
        },
        {
          "name": "Gloves used correctly where required",
          "priority": "high"
        },
        {
          "name": "Uniforms are not visibly soiled",
          "priority": "normal"
        }
      ]
    },
    {
      "name": "Stores, FIFO & Raw Material Control",
      "shortName": "FIFO & Stores",
      "key": "fifo",
      "critical": true,
      "checkpoints": [
        {
          "name": "FIFO followed correctly",
          "priority": "critical"
        },
        {
          "name": "FEFO followed where applicable",
          "priority": "high"
        },
        {
          "name": "Oldest stock positioned for first use",
          "priority": "high"
        },
        {
          "name": "New stock placed behind existing stock",
          "priority": "high"
        },
        {
          "name": "All materials properly labelled",
          "priority": "normal"
        },
        {
          "name": "Receiving date visible",
          "priority": "normal"
        },
        {
          "name": "Expiry / use-by date visible",
          "priority": "high"
        },
        {
          "name": "Opened products have opening date recorded",
          "priority": "normal"
        },
        {
          "name": "No expired raw materials in usable stock",
          "priority": "critical"
        },
        {
          "name": "Damaged packaging identified and segregated",
          "priority": "normal"
        },
        {
          "name": "Ingredients stored at correct temperature",
          "priority": "critical"
        },
        {
          "name": "Dry store is clean and organized",
          "priority": "normal"
        },
        {
          "name": "Chilled / frozen stores are clean and organized",
          "priority": "normal"
        },
        {
          "name": "Raw materials stored off the floor",
          "priority": "normal"
        },
        {
          "name": "Food materials separated from chemicals / non-food items",
          "priority": "high"
        }
      ]
    },
    {
      "name": "Production Planning",
      "shortName": "Production Planning",
      "key": "planning",
      "critical": false,
      "checkpoints": [
        {
          "name": "Daily production plan is available",
          "priority": "high"
        },
        {
          "name": "Production plan matches confirmed orders / requirements",
          "priority": "high"
        },
        {
          "name": "Previous day's pending production has been reviewed",
          "priority": "normal"
        },
        {
          "name": "Raw material availability checked before production",
          "priority": "high"
        },
        {
          "name": "Packaging material availability checked",
          "priority": "normal"
        },
        {
          "name": "Production quantities clearly defined",
          "priority": "normal"
        },
        {
          "name": "Production priorities communicated to the team",
          "priority": "normal"
        },
        {
          "name": "Production schedule is practical and achievable",
          "priority": "normal"
        },
        {
          "name": "Special / custom orders clearly identified",
          "priority": "normal"
        },
        {
          "name": "Urgent orders communicated to the relevant team",
          "priority": "normal"
        },
        {
          "name": "Wastage / rejection from previous production reviewed",
          "priority": "normal"
        },
        {
          "name": "Production plan updated when requirements change",
          "priority": "normal"
        }
      ]
    },
    {
      "name": "Production Execution",
      "shortName": "Production",
      "key": "execution",
      "critical": false,
      "checkpoints": [
        {
          "name": "Correct product is being produced",
          "priority": "high"
        },
        {
          "name": "Correct recipe / formulation being followed",
          "priority": "high"
        },
        {
          "name": "Correct batch quantity being produced",
          "priority": "normal"
        },
        {
          "name": "Correct portion / weight maintained",
          "priority": "high"
        },
        {
          "name": "Batch identification maintained",
          "priority": "high"
        },
        {
          "name": "Production sequence followed",
          "priority": "normal"
        },
        {
          "name": "Oven / baking parameters followed",
          "priority": "high"
        },
        {
          "name": "Proofing parameters followed where applicable",
          "priority": "normal"
        },
        {
          "name": "Cooling process followed correctly",
          "priority": "normal"
        },
        {
          "name": "Product handled hygienically after baking",
          "priority": "high"
        },
        {
          "name": "Rework is properly identified and controlled",
          "priority": "normal"
        },
        {
          "name": "Production wastage is recorded",
          "priority": "normal"
        },
        {
          "name": "Finished quantities match production plan",
          "priority": "normal"
        }
      ]
    },
    {
      "name": "Product Quality",
      "shortName": "Quality",
      "key": "quality",
      "critical": false,
      "checkpoints": [
        {
          "name": "Product appearance meets standard",
          "priority": "high"
        },
        {
          "name": "Correct size / weight",
          "priority": "high"
        },
        {
          "name": "Correct colour",
          "priority": "normal"
        },
        {
          "name": "Correct texture",
          "priority": "normal"
        },
        {
          "name": "Correct filling quantity",
          "priority": "normal"
        },
        {
          "name": "Product is properly baked / cooked",
          "priority": "high"
        },
        {
          "name": "No burnt or under-baked products",
          "priority": "high"
        },
        {
          "name": "No damaged / deformed products",
          "priority": "normal"
        },
        {
          "name": "Product temperature checked where applicable",
          "priority": "normal"
        },
        {
          "name": "Finished product tasting / QC carried out",
          "priority": "high"
        },
        {
          "name": "Product meets approved specification",
          "priority": "high"
        },
        {
          "name": "Rejected products are segregated",
          "priority": "normal"
        }
      ]
    },
    {
      "name": "Equipment & Maintenance",
      "shortName": "Equipment",
      "key": "equipment",
      "critical": false,
      "checkpoints": [
        {
          "name": "Ovens functioning correctly",
          "priority": "high"
        },
        {
          "name": "Mixers functioning correctly",
          "priority": "high"
        },
        {
          "name": "Proofers functioning correctly",
          "priority": "normal"
        },
        {
          "name": "Refrigerators / freezers functioning correctly",
          "priority": "high"
        },
        {
          "name": "Temperature displays working",
          "priority": "high"
        },
        {
          "name": "Weighing scales accurate",
          "priority": "high"
        },
        {
          "name": "Equipment cleaned after use",
          "priority": "normal"
        },
        {
          "name": "No oil / grease leakage",
          "priority": "normal"
        },
        {
          "name": "Electrical wiring / plugs appear safe",
          "priority": "critical"
        },
        {
          "name": "Preventive maintenance schedule followed",
          "priority": "normal"
        },
        {
          "name": "Breakdown issues recorded",
          "priority": "normal"
        },
        {
          "name": "Defective equipment tagged / segregated where required",
          "priority": "high"
        }
      ]
    },
    {
      "name": "Cleaning & Sanitation",
      "shortName": "Cleaning",
      "key": "cleaning",
      "critical": false,
      "checkpoints": [
        {
          "name": "Production tables clean",
          "priority": "high"
        },
        {
          "name": "Work surfaces sanitized",
          "priority": "high"
        },
        {
          "name": "Mixers cleaned",
          "priority": "high"
        },
        {
          "name": "Ovens cleaned",
          "priority": "normal"
        },
        {
          "name": "Trays / racks clean",
          "priority": "normal"
        },
        {
          "name": "Floors clean",
          "priority": "normal"
        },
        {
          "name": "Drains clean",
          "priority": "normal"
        },
        {
          "name": "Walls / tiles reasonably clean",
          "priority": "normal"
        },
        {
          "name": "Cleaning schedule completed",
          "priority": "normal"
        },
        {
          "name": "Cleaning chemicals correctly labelled",
          "priority": "high"
        },
        {
          "name": "Cleaning equipment stored hygienically",
          "priority": "normal"
        },
        {
          "name": "Waste bins clean and covered",
          "priority": "normal"
        },
        {
          "name": "No accumulated food residue",
          "priority": "high"
        }
      ]
    },
    {
      "name": "Packaging & Labelling",
      "shortName": "Packaging",
      "key": "packaging",
      "critical": false,
      "checkpoints": [
        {
          "name": "Correct packaging material used",
          "priority": "normal"
        },
        {
          "name": "Packaging is clean and undamaged",
          "priority": "high"
        },
        {
          "name": "Correct product label used",
          "priority": "high"
        },
        {
          "name": "Product name correct",
          "priority": "high"
        },
        {
          "name": "Batch number present",
          "priority": "high"
        },
        {
          "name": "Manufacturing / production date present",
          "priority": "high"
        },
        {
          "name": "Expiry / best-before information correct",
          "priority": "critical"
        },
        {
          "name": "Storage instructions correct",
          "priority": "normal"
        },
        {
          "name": "Allergen declaration checked where applicable",
          "priority": "critical"
        },
        {
          "name": "Quantity / weight correct",
          "priority": "normal"
        },
        {
          "name": "Packaging properly sealed",
          "priority": "normal"
        },
        {
          "name": "Finished products protected from contamination",
          "priority": "high"
        }
      ]
    },
    {
      "name": "Dispatch Checklist",
      "shortName": "Dispatch",
      "key": "dispatch",
      "critical": true,
      "checkpoints": [
        {
          "name": "Dispatch list / order sheet available",
          "priority": "high"
        },
        {
          "name": "Correct customer / outlet",
          "priority": "critical"
        },
        {
          "name": "Correct product",
          "priority": "critical"
        },
        {
          "name": "Correct quantity",
          "priority": "critical"
        },
        {
          "name": "Correct SKU",
          "priority": "high"
        },
        {
          "name": "Correct batch",
          "priority": "high"
        },
        {
          "name": "Correct packaging",
          "priority": "normal"
        },
        {
          "name": "Labels checked",
          "priority": "high"
        },
        {
          "name": "Expiry / best-before checked",
          "priority": "critical"
        },
        {
          "name": "Product condition checked",
          "priority": "high"
        },
        {
          "name": "Frozen / chilled product temperature checked",
          "priority": "critical"
        },
        {
          "name": "Dispatch temperature recorded where required",
          "priority": "critical"
        },
        {
          "name": "Delivery vehicle / transport condition checked",
          "priority": "normal"
        },
        {
          "name": "Products packed securely",
          "priority": "normal"
        },
        {
          "name": "No damaged packaging",
          "priority": "normal"
        },
        {
          "name": "Dispatch quantity matches order",
          "priority": "critical"
        },
        {
          "name": "Dispatch documentation completed",
          "priority": "high"
        },
        {
          "name": "Loading completed correctly",
          "priority": "normal"
        }
      ]
    },
    {
      "name": "Documentation, Traceability & Records",
      "shortName": "Documentation",
      "key": "documentation",
      "critical": false,
      "checkpoints": [
        {
          "name": "Production records completed",
          "priority": "high"
        },
        {
          "name": "Batch records completed",
          "priority": "high"
        },
        {
          "name": "Temperature logs updated",
          "priority": "high"
        },
        {
          "name": "Cleaning records updated",
          "priority": "normal"
        },
        {
          "name": "Pest-control records available",
          "priority": "high"
        },
        {
          "name": "Equipment maintenance records updated",
          "priority": "normal"
        },
        {
          "name": "Raw material receiving records maintained",
          "priority": "normal"
        },
        {
          "name": "Rejection / wastage records maintained",
          "priority": "normal"
        },
        {
          "name": "Dispatch records completed",
          "priority": "high"
        },
        {
          "name": "Corrective actions from previous audit closed",
          "priority": "high"
        },
        {
          "name": "Product traceability possible from batch number",
          "priority": "critical"
        }
      ]
    },
    {
      "name": "Overall Bakery Execution",
      "shortName": "Overall Execution",
      "key": "execution_overall",
      "critical": false,
      "checkpoints": [
        {
          "name": "Production area is organized",
          "priority": "normal"
        },
        {
          "name": "Workflows are efficient",
          "priority": "normal"
        },
        {
          "name": "Staff know their responsibilities",
          "priority": "normal"
        },
        {
          "name": "Production plan is being followed",
          "priority": "normal"
        },
        {
          "name": "Hygiene standards consistently maintained",
          "priority": "high"
        },
        {
          "name": "Stores are organized",
          "priority": "normal"
        },
        {
          "name": "FIFO discipline is visible",
          "priority": "high"
        },
        {
          "name": "Production targets are being achieved",
          "priority": "normal"
        },
        {
          "name": "Quality standards are maintained",
          "priority": "high"
        },
        {
          "name": "Dispatch is organized",
          "priority": "normal"
        },
        {
          "name": "Wastage is under control",
          "priority": "normal"
        },
        {
          "name": "Previous audit issues have been corrected",
          "priority": "high"
        },
        {
          "name": "Bakery is operating in a controlled and professional manner",
          "priority": "normal"
        }
      ]
    }
  ],
  "Weekly": [
    {
      "name": "Stores / FIFO / FEFO",
      "shortName": "FIFO & Stores",
      "key": "fifo",
      "critical": true,
      "checkpoints": [
        {
          "name": "FIFO being followed",
          "priority": "critical"
        },
        {
          "name": "FEFO being followed where applicable",
          "priority": "high"
        },
        {
          "name": "Oldest stock positioned for use",
          "priority": "high"
        },
        {
          "name": "New stock placed behind old stock",
          "priority": "high"
        },
        {
          "name": "No expired raw materials",
          "priority": "critical"
        },
        {
          "name": "Opened materials dated",
          "priority": "normal"
        },
        {
          "name": "All materials correctly labelled",
          "priority": "normal"
        },
        {
          "name": "Receiving dates available",
          "priority": "normal"
        },
        {
          "name": "Expiry dates visible",
          "priority": "high"
        },
        {
          "name": "Damaged packaging segregated",
          "priority": "normal"
        },
        {
          "name": "Raw materials stored correctly",
          "priority": "high"
        },
        {
          "name": "Materials stored off the floor",
          "priority": "normal"
        },
        {
          "name": "Dry store clean and organized",
          "priority": "normal"
        },
        {
          "name": "Chiller organized",
          "priority": "normal"
        },
        {
          "name": "Freezer organized",
          "priority": "normal"
        },
        {
          "name": "Food materials separated from chemicals / non-food items",
          "priority": "high"
        },
        {
          "name": "Temperature records reviewed",
          "priority": "high"
        }
      ]
    },
    {
      "name": "Equipment & Maintenance",
      "shortName": "Equipment",
      "key": "equipment",
      "critical": false,
      "checkpoints": [
        {
          "name": "Ovens functioning correctly",
          "priority": "high"
        },
        {
          "name": "Mixers functioning correctly",
          "priority": "high"
        },
        {
          "name": "Proofers functioning correctly",
          "priority": "normal"
        },
        {
          "name": "Refrigerators functioning correctly",
          "priority": "high"
        },
        {
          "name": "Freezers functioning correctly",
          "priority": "high"
        },
        {
          "name": "Temperature displays functioning",
          "priority": "high"
        },
        {
          "name": "Weighing scales functioning / verified",
          "priority": "high"
        },
        {
          "name": "Equipment deep-cleaning completed",
          "priority": "normal"
        },
        {
          "name": "No oil / grease leakage",
          "priority": "normal"
        },
        {
          "name": "Electrical points appear safe",
          "priority": "critical"
        },
        {
          "name": "Preventive maintenance schedule reviewed",
          "priority": "normal"
        },
        {
          "name": "Breakdown issues recorded",
          "priority": "normal"
        },
        {
          "name": "Pending maintenance issues reviewed",
          "priority": "normal"
        },
        {
          "name": "Defective equipment properly identified",
          "priority": "high"
        }
      ]
    },
    {
      "name": "Documentation & Traceability",
      "shortName": "Documentation",
      "key": "documentation",
      "critical": false,
      "checkpoints": [
        {
          "name": "Production records complete",
          "priority": "high"
        },
        {
          "name": "Batch records complete",
          "priority": "high"
        },
        {
          "name": "Temperature logs complete",
          "priority": "high"
        },
        {
          "name": "Cleaning records complete",
          "priority": "normal"
        },
        {
          "name": "Pest-control records available / reviewed",
          "priority": "high"
        },
        {
          "name": "Maintenance records updated",
          "priority": "normal"
        },
        {
          "name": "Raw material receiving records maintained",
          "priority": "normal"
        },
        {
          "name": "Wastage / rejection records maintained",
          "priority": "normal"
        },
        {
          "name": "Dispatch records complete",
          "priority": "high"
        },
        {
          "name": "Previous audit corrective actions reviewed",
          "priority": "high"
        },
        {
          "name": "Traceability test possible using a batch number",
          "priority": "critical"
        }
      ]
    },
    {
      "name": "Overall Bakery Compliance",
      "shortName": "Overall Compliance",
      "key": "compliance",
      "critical": false,
      "checkpoints": [
        {
          "name": "Bakery overall organization is satisfactory",
          "priority": "normal"
        },
        {
          "name": "Production flow is efficient",
          "priority": "normal"
        },
        {
          "name": "Staff responsibilities are clear",
          "priority": "normal"
        },
        {
          "name": "Hygiene standards consistently maintained",
          "priority": "high"
        },
        {
          "name": "FIFO discipline consistently maintained",
          "priority": "high"
        },
        {
          "name": "Production planning is effective",
          "priority": "normal"
        },
        {
          "name": "Product quality is consistent",
          "priority": "high"
        },
        {
          "name": "Dispatch process is controlled",
          "priority": "high"
        },
        {
          "name": "Wastage is under control",
          "priority": "normal"
        },
        {
          "name": "Equipment maintenance is under control",
          "priority": "normal"
        },
        {
          "name": "Previous audit issues have been closed",
          "priority": "high"
        },
        {
          "name": "Corrective actions are being followed up",
          "priority": "high"
        }
      ]
    }
  ]
};

export const AUDIT_PRIORITIES = ["normal", "high", "critical"];
